export const type = 'DRAWER'

const TOGGLE = `TOGGLE_${type}`

export const toggleDrawer = () => ({ type: TOGGLE })



// WEBPACK FOOTER //
// ./src/actions/drawer.js